<nav class="sidebar-nav">
  @if (favoriteItems().length > 0) {
    <ul class="nav nav-favorites">
      <li class="nav-title">Preferiti</li>
      @for (item of favoriteItems(); track item.url) {
        <li class="nav-item nav-item-pinnable">
          <a
            [routerLink]="item.url"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            class="nav-link"
            (click)="itemClicked.emit(); hoveredItem = null">

            <i [class]="item.icon" class="nav-icon"></i>
            <span>{{ item.name }}</span>
            <span class="nav-flyout">{{ item.name }}</span>
          </a>
          <button
            type="button"
            class="nav-pin is-pinned"
            title="Rimuovi dai preferiti"
            aria-label="Rimuovi dai preferiti"
            (click)="unpin(item.url, $event)">
            <fa-icon [icon]="['fas', 'thumbtack']" aria-hidden="true"></fa-icon>
          </button>
        </li>
      }
    </ul>
    <div class="nav-divider"></div>
  }

  <ul class="nav">
    <ng-container *ngTemplateOutlet="navItemTpl; context: { $implicit: navItems }"></ng-container>
  </ul>
</nav>

<ng-template #navItemTpl let-items>
  @for (item of items; track trackNavItem($index, item)) {
    <!-- Divider -->
    @if (item.divider) {
      <li class="nav-divider"></li>
    }
    <!-- Title -->
    @if (item.title) {
      <li class="nav-title">{{ item.name }}</li>
    }
    <!-- Regular Nav Item -->
    @if (!item.divider && !item.title && !item.children) {
      <li class="nav-item" [class.nav-item-pinnable]="canPin(item)">
        <a
          [routerLink]="item.url"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="nav-link"
          (click)="itemClicked.emit(); hoveredItem = null"
          >
          <i [class]="item.icon" class="nav-icon"></i>
          <span>{{ item.name }}</span>
          <span class="nav-flyout">{{ item.name }}</span>
        </a>
        @if (canPin(item)) {
          <button
            type="button"
            class="nav-pin"
            [class.is-pinned]="isFavorite(item.url)"
            [title]="isFavorite(item.url) ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'"
            [attr.aria-label]="isFavorite(item.url) ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'"
            (click)="togglePin(item, $event)">
            <fa-icon [icon]="['fas', 'thumbtack']" aria-hidden="true"></fa-icon>
          </button>
        }
      </li>
    }
    <!-- Nav Item with Children -->
    @if (!item.divider && !item.title && item.children && item.children.length > 0) {
      <li class="nav-item"
        (mouseenter)="hoveredItem = item"
        (mouseleave)="hoveredItem = null">
        <a
          href="javascript:void(0)"
          class="nav-link"
          [class.collapsed]="!isExpanded(item)"
          (click)="toggleExpand(item)"
          >
          <i [class]="item.icon" class="nav-icon"></i>
          <span>{{ item.name }}</span>
          <i class="nav-expand-icon fa" [class.fa-chevron-down]="isExpanded(item)" [class.fa-chevron-right]="!isExpanded(item)"></i>
        </a>
        @if (isExpanded(item) && !minimized) {
          <ul class="nav-children show">
            <li class="nav-children-title">{{ item.name }}</li>
            <ng-container *ngTemplateOutlet="navItemTpl; context: { $implicit: item.children }"></ng-container>
          </ul>
        }
        @if (minimized && hoveredItem === item) {
          <ul class="nav-children flyout">
            <li class="nav-children-title">{{ item.name }}</li>
            <ng-container *ngTemplateOutlet="navItemTpl; context: { $implicit: item.children }"></ng-container>
          </ul>
        }
      </li>
    }
  }
</ng-template>
